var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageTagline',{attrs:{"elements":_vm.tagline_elem}}),_c('TutorialContestuale',{attrs:{"video_to_show":['tutorial_parchi_divertimento']}}),_c('TsLoginPage',{attrs:{"service_title":_vm.service_title,"service":_vm.service,"cluster":_vm.cluster,"comp_credito":_vm.comp_credito}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }